import { NEWBUILDING_BUZZOLA_INTEGRATION_TEST_WEB } from 'shared/hooks/selectors/useNewbuildingBuzzoolaIntegrationTestWebAvailable';
import {
  NEWBUILDING_TRUST_AND_SAFETY,
  NEWBUILDING_RENT_TRAP,
  NEWBUILDING_SUBURBAN_TRAP,
  NEWBUILDING_FLAT_SALE_TRAP,
  PRICE_CLOSED_AUTH,
  AUD_HIDE_PHONE_NUMBER_EXPERIMENT,
} from 'shared/selectors/abExperiments';
import { CPD_TRAP_EXPERIMENT_NAME } from 'shared/selectors/abExperiments/selectCPDTrapGroup';

export const EXPERIMENTS: string[] = [
  NEWBUILDING_TRUST_AND_SAFETY,
  NEWBUILDING_RENT_TRAP,
  NEWBUILDING_SUBURBAN_TRAP,
  NEWBUILDING_FLAT_SALE_TRAP,
  PRICE_CLOSED_AUTH,
  AUD_HIDE_PHONE_NUMBER_EXPERIMENT,
  /**
   * @todo Удалить переменную
   * @description Данный функционал появился в задаче CD-243382, будет удалён в задаче CD-245101
   */
  NEWBUILDING_BUZZOLA_INTEGRATION_TEST_WEB,
  CPD_TRAP_EXPERIMENT_NAME,
];
